import { defineMessages } from 'react-intl';

export default defineMessages({
  myServices: {
    id: 'dashboard_amc.my_services',
  },
  findDoctor: {
    id: 'dashboard_amc.find_doctor',
  },
  findAgent: {
    id: 'dashboard_amc.find_agent',
  },
  medicationList: {
    id: 'Home.text.Health.liste_des_medicadement',
  },
  dmoDelarations: {
    id: 'dmo_Home_text_Health_mes_declaration',
  },
  drugstores: {
    id: 'Home.text.Health.pharmacies_de_garde',
  },
});
